import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import ComplementoArrendamientoenfideicomisoRules from '../../support/rules/complementos/ComplementoArrendamientoenfideicomisoRules.js';

const rules = ComplementoArrendamientoenfideicomisoRules;

const ComplementoArrendamientoenfideicomiso = (props) => {
  const [data, setData] = useState({});
  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      Version: '1.0',
      ...data,
      ...event,
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => {
    validate(data);
  }, [data]);

  const handleOnComplementoAdd = () => {
    const Arrendamientoenfideicomiso = data;

    props.onComplementoAdd({ Arrendamientoenfideicomiso });

    clearData();
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  const clearData = () => {
    setData({});
  };

  return (
    <>
      <Row>
        <Col>
          <h5 className="text-right">Arrendamiento en fideicomiso</h5>
        </Col>
      </Row>

      <Form autoComplete="off">
        <Row>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Pago efectuado"
              name="PagProvEfecPorFiduc"
              placeholder=""
              help=""
              rules={rules.PagProvEfecPorFiduc}
              value={data.PagProvEfecPorFiduc}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto rendimientos"
              name="RendimFideicom"
              placeholder=""
              help=""
              rules={rules.RendimFideicom}
              value={data.RendimFideicom}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Deducciones"
              name="DeduccCorresp"
              placeholder=""
              help=""
              rules={rules.DeduccCorresp}
              value={data.DeduccCorresp}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto total retenido"
              name="MontTotRet"
              placeholder=""
              help=""
              rules={rules.MontTotRet}
              value={data.MontTotRet}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto del resultado fiscal distribuido por FIBRAS"
              name="MontResFiscDistFibras"
              placeholder=""
              help=""
              rules={rules.MontResFiscDistFibras}
              value={data.MontResFiscDistFibras}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto otros conceptos distribuidos"
              name="MontOtrosConceptDistr"
              placeholder=""
              help=""
              rules={rules.MontOtrosConceptDistr}
              value={data.MontOtrosConceptDistr}
              onChange={handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col sm md={12}>
            <FormControl
              as="textarea"
              label="Descripción otros conceptos distribuidos"
              name="DescrMontOtrosConceptDistr"
              placeholder=""
              help=""
              rows="3"
              maxLength="256"
              rules={rules.DescrMontOtrosConceptDistr}
              value={data.DescrMontOtrosConceptDistr}
              onChange={handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              variant="secondary"
              className="mr-2"
              onClick={handleOutForm}
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={!isValid}
              onClick={handleOnComplementoAdd}
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ComplementoArrendamientoenfideicomiso;
